module.exports = __webpack_public_path__ + "media/images/projects/10-dashboard-78a9e88a719253ac1eabfb440dfcdcba.jpg";